// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/style/index.scss
// module id = 3698
// module chunks = 0